import React from 'react';
import { Building2, TreePine, Briefcase } from 'lucide-react';

const GolfPresentation = () => {
  const partners = [
    {
      icon: Briefcase,
      role: 'Aménageur territorial',
      name: 'One Green Dev',
    },
    {
      icon: Building2,
      role: 'Architecture',
      name: 'Nicolas Duchateau',
    },
    {
      icon: TreePine,
      role: 'Parcours Golf',
      name: 'Alain Cnrjac',
    },
  ];

  return (
    <section className="py-24 lg:py-32 bg-white relative overflow-hidden" data-testid="projet-section">
      {/* Subtle Background Pattern */}
      <div className="absolute inset-0 opacity-[0.015]">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 1px 1px, #1a3c2a 1px, transparent 0)`,
          backgroundSize: '48px 48px'
        }} />
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        {/* Editorial Layout */}
        <div className="relative">
          {/* Image - Dominant */}
          <div className="lg:w-[55%]">
            <div className="relative">
              <div className="aspect-square overflow-hidden rounded-lg shadow-2xl">
                <img
                  src="https://customer-assets.emergentagent.com/job_ab5938d0-e883-4589-ba7b-f375ea61faf7/artifacts/d9vvv6pc_projet.png"
                  alt="Les Terres de Songon Golf Club - Vue aérienne"
                  className="w-full h-full object-cover"
                  data-testid="projet-image"
                />
              </div>
              {/* Gold Corner Accents */}
              <div className="absolute -top-3 -left-3 w-20 h-20 border-l-2 border-t-2 border-[#c9a962] pointer-events-none" />
              <div className="absolute -bottom-3 -right-3 w-20 h-20 border-r-2 border-b-2 border-[#c9a962] pointer-events-none hidden lg:block" />
            </div>
          </div>

          {/* Text Panel - Overlapping on desktop */}
          <div className="relative mt-10 lg:mt-0 lg:absolute lg:right-0 lg:top-1/2 lg:-translate-y-1/2 lg:w-[50%]">
            <div className="bg-white lg:bg-white/95 lg:backdrop-blur-sm lg:shadow-[0_8px_60px_-12px_rgba(0,0,0,0.12)] lg:rounded-xl lg:p-10 xl:p-12">
              {/* Label */}
              <span className="font-montserrat text-[#c9a962] text-[10px] tracking-[0.4em] uppercase">
                Le Projet
              </span>
              <div className="w-12 h-px bg-[#c9a962] mt-4 mb-6" />

              {/* Title */}
              <h2 className="font-playfair text-3xl lg:text-4xl xl:text-5xl text-[#1a3c2a] leading-[1.15] mb-6">
                Golf des Terres
                <span className="block text-[#c9a962] italic">de Songon</span>
              </h2>

              {/* Description - Prestigious tone */}
              <p className="font-montserrat text-base text-gray-600 leading-relaxed mb-4">
                Porté par <span className="text-[#1a3c2a] font-medium">One Green Dev</span>, 
                aménageur territorial de ce domaine d'exception, le projet unit l'expertise de 
                <span className="text-[#1a3c2a] font-medium"> Nicolas Duchateau</span> pour 
                l'architecture et d'<span className="text-[#1a3c2a] font-medium">Alain Cnrjac</span> pour 
                la conception du parcours.
              </p>

              <p className="font-montserrat text-sm text-gray-400 leading-relaxed mb-8">
                Un sanctuaire verdoyant aux portes du Grand Abidjan, 
                où 9 trous aux normes USGA s'intègrent dans un cadre 
                résidentiel de prestige, bercé par le calme absolu 
                et la nature luxuriante de Songon.
              </p>

              {/* Partner Credits */}
              <div className="border-t border-gray-100 pt-6">
                <div className="grid grid-cols-3 gap-4">
                  {partners.map((partner, index) => (
                    <div key={index} className="text-center">
                      <div className="w-9 h-9 mx-auto mb-2.5 rounded-full bg-[#1a3c2a]/5 flex items-center justify-center">
                        <partner.icon className="w-4 h-4 text-[#c9a962]" />
                      </div>
                      <p className="font-montserrat text-[9px] tracking-[0.15em] uppercase text-gray-300 mb-1">
                        {partner.role}
                      </p>
                      <p className="font-playfair text-sm text-[#1a3c2a]">
                        {partner.name}
                      </p>
                    </div>
                  ))}
                </div>
              </div>

              {/* Delivery Badge */}
              <div className="mt-6 pt-6 border-t border-gray-100 flex items-center gap-4">
                <div className="bg-[#1a3c2a] px-5 py-3 rounded-lg">
                  <p className="font-playfair text-2xl text-[#c9a962] leading-none">2027</p>
                </div>
                <div>
                  <p className="font-montserrat text-[10px] tracking-[0.2em] uppercase text-gray-300">Livraison estimée</p>
                  <p className="font-montserrat text-sm text-[#1a3c2a] font-medium">Songon, Côte d'Ivoire</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GolfPresentation;
